<template>
<v-container fluid>
    <v-card class="ma-2" outlined>
        <v-card-title>
            <v-icon class="mr-1" color="green">mdi-file-table-box-multiple-outline</v-icon>
            Challenge
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            <v-btn color="primary" dark class="ml-5 mt-3" @click="showNewChallengePopup" v-if="isSuperAdmin || isAccessPILMAdmin">
                + ADD
            </v-btn>
        </v-card-title>
        <v-progress-linear indeterminate color="blue darken-2" v-if="loading"></v-progress-linear>

        <!-- Dialog for confirm delete user -->
        <v-dialog v-model="dialogItem.deleteConfirmation" max-width="400px">
            <v-card>
                <v-card-title class="text">{{ dialogItem.confirmText }}</v-card-title>
                <v-card-actions v-if="dialogItem.confirmAction">
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeConfirmationDialog">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
                <v-card-actions v-else>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="actionDeleteChallenge">Yes</v-btn>
                    <v-btn color="blue darken-1" text @click="closeConfirmationDialog">No</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- table list -->
        <v-data-table v-if="challengeList.length" :headers="headers" :items="challengeList" :search="search" sort-by="endDate" :sort-desc="true" :footer-props="{ 'items-per-page-options': [10, 20, 30, 50, 100, -1] }" :options="options" @click:row="goToSummary" :loading="loading">
            <template v-slot:[`item.startDate`]="{ item }">
                <span>
                    {{ _formatData("date", item.startDateText) }}
                </span>
            </template>
            <template v-slot:[`item.endDate`]="{ item }">
                <span>
                    {{ _formatData("date", item.endDateText) }}
                </span>
            </template>
            <template v-slot:[`item.status`]="{ item }">
                <v-chip v-if="item.isCompleted" class="ma-2" x-small color="green" text-color="white">
                    Finished
                </v-chip>
                <v-chip v-else-if="item.isStarted" class="ma-2" x-small color="orange" text-color="white">
                    Running
                </v-chip>
                <v-chip v-else class="ma-2" x-small>
                    Not start
                </v-chip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-btn icon class="mr-2" @click="goToSummary(item)" :href="getGoToSummaryUrl(item)" title="Summary">
                    <v-icon>
                        mdi-chart-box
                    </v-icon>
                </v-btn>
                <v-btn icon class="mr-2" @click="goToGroupList(item, 'verify')" :href="getChallengeVerifyUrl(item)" title="Verify">
                    <v-icon>
                        mdi-file-sign
                    </v-icon>
                </v-btn>
                <v-btn icon class="mr-2" @click="editChallengeAction(item)" :href="getEditChallengeActionUrl(item)" title="Edit" v-if="isSuperAdmin || (isAccessPILMAdmin && item.owner == loggedInUserId)">
                    <v-icon>
                        mdi-pencil
                    </v-icon>
                </v-btn>
                <v-icon v-if="!item.isStarted && (isSuperAdmin || (isAccessPILMAdmin && item.owner == loggedInUserId))" class="mr-2" @click="dialogDeleteChallenge(item)" title="Delete">
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
        <v-card-subtitle v-else>No item list</v-card-subtitle>
    </v-card>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import formatData from "../utils/formatData";
import getChallengeList from "../data/getChallengeList";
import removeChallenge from "../data/removeChallenge";
export default {
    name: 'ChallengePage',
    metaInfo: {
        title: 'Challenge'
    },
    data() {
        return {
            loading: false,
            search: "",
            options: {
                itemsPerPage: 20,
            },
            headers: [{
                    text: "Name",
                    value: "name",
                },
                {
                    text: "Owner",
                    value: "admin.name"
                },
                {
                    text: "Status",
                    value: "status"
                },
                {
                    text: "Details",
                    value: "details",
                    width: '30%'
                },
                {
                    text: "Start date",
                    value: "startDate",
                },
                {
                    text: "End date",
                    value: "endDate",
                },
                {
                    text: "Actions",
                    value: "actions",
                    sortable: false,
                },
            ],
            challengeList: [],

            dialogItem: {
                confirmAction: false,
                confirmText: "Do you want to delete this challenge?",
                deleteConfirmation: false,
                deletedItemId: null,
            },
            dialogItemDefault: {
                confirmAction: false,
                confirmText: "Do you want to delete this challenge?",
                deleteConfirmation: false,
                deletedItemId: null,
            }
        };
    },
    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Challenge";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });
    },
    computed: {
        ...mapGetters([
            "loggedInUserId",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
            "isAccessPILMAdmin"
        ]),
    },
    methods: {
        initialize() {
            if (this.isSuperAdmin || this.isChallengeAdmin) {
                (async () => {
                    this.loading = true;
                    if (this.isSuperAdmin) {
                        this.challengeList = await getChallengeList();
                    } else if (this.isChallengeAdmin) {
                        this.challengeList = await getChallengeList(this.loggedInUserId);
                    }
                    this.loading = false;
                })();
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        _formatData(type, value) {
            return formatData(type, value);
        },
        //dialog
        showNewChallengePopup() {
            this.$router.push(`/challenge-add`);
        },
        editChallengeAction(item) {
            this.$router.push(`/challenge-edit/${item.id}`);
        },
        getEditChallengeActionUrl(item) {
            return `/challenge-edit/${item.id}`;
        },

        //delete
        dialogDeleteChallenge(item) {
            this.dialogItem.deleteConfirmation = true; //show popup
            this.dialogItem.deletedItemId = item.id; //assign delete item id

            this.dialogItem.confirmAction = this.dialogItemDefault.confirmAction;
            this.dialogItem.confirmText = this.dialogItemDefault.confirmText;
        },
        actionDeleteChallenge() {
            (async () => {
                await removeChallenge(this.dialogItem.deletedItemId);
                this.dialogItem.confirmAction = true;
                this.dialogItem.confirmText = "Done!";

                this.dialogItem.deleteConfirmation = false;
                this.dialogItem.deletedItemId = this.dialogItemDefault.deletedItemId; //assign delete item id
                await this.initialize();
            })();
        },
        closeConfirmationDialog() {
            //To result default value
            this.dialogItem.deleteConfirmation = false;
            this.dialogItem.deletedItemId = this.dialogItemDefault.deletedItemId; //assign delete item id
            this.dialogItem.confirmAction = this.dialogItemDefault.confirmAction;
            this.dialogItem.confirmText = this.dialogItemDefault.confirmText;
        },

        //router
        goToGroupList(item, type) {
            if (type == "summary") {
                this.$router.push(`/challengesummary/${item.id}`);
            } else if (type == "verify") {
                this.$router.push(`/challengeverify/${item.id}`);
            } else {
                this.$router.push(`/challenge/${item.id}`);
            }
        },

        getChallengeVerifyUrl(item) {
            return `/challengeverify/${item.id}`;
        },
        goToSummary(item){
            if( item.isStarted ) {
                this.$router.push(`/challengesummary/${item.id}`);
            }
        },
        getGoToSummaryUrl(item) {
            return `/challengesummary/${item.id}`;
        }
    },
};
</script>